import React from "react";
import "../components/componentstyle/about.css";
import aboutImg1 from "../assets/abt-img-1.jpg";
import aboutImg2 from "../assets/abt-img-2.jpg";
import infraImage from "../assets/recent-img2.jpg";
import ChangeAlbeHeader from "./ChangeAbleHeader";

function About() {
  return (
    <>
      <ChangeAlbeHeader>About Us</ChangeAlbeHeader>

      <div className="about-info container pt-5 d-flex">
        <div className="imgeDiv">
          <img src={aboutImg1} alt="" />
        </div>
        <div className="info-txt">
          <p>
            Bringing India to the World — Professionally, Passionately, Globally
          </p>
          <p>
            Established in 2023 and headquartered in Surat, Gujarat — one of
            India’s fastest-growing commercial hubs — we are a trusted export
            company dedicated to delivering India’s finest products to the
            global marketplace. With a strong foundation in international trade,
            we offer a wide portfolio of export solutions across various
            industries, tailored to meet the diverse needs of our clients.
          </p>
          <p>
            Over the past 2 years, we’ve built our reputation through integrity,
            quality assurance, and customer-centric service. Our company is
            driven by a commitment to excellence in everything we do — from
            sourcing and compliance to packaging and logistics.
          </p>
          <p>
            We serve global partners across the USA, Europe, Middle East,
            Africa, and Asia, ensuring each consignment reflects the best of
            what India has to offer.
          </p>
        </div>
      </div>

      <section className="infrastructure-section">
        <div className="infra-left-bar"></div>
        <div className="infra-content">
          <h2 className="infra-heading">Infrastructure</h2>
          <h3 className="infra-subheading">
            Our main office is situated in Nagpur, the center of India.
          </h3>
          <p className="infra-description">
            We additionally have workplaces, warehouse and the professional
            experienced staff present in 5 vital growing areas in India and 5
            major Indian ports. Till date, the company keeps up its firm
            obligation to morals and transparency.
          </p>
        </div>
      </section>
      <div className="infra-image-box">
        <img src={infraImage} alt="Grains" />
      </div>

      <div className="about-info container d-flex">
        <div className="imgeDiv">
          <img src={aboutImg2} alt="" style={{ height: "28rem" }} />
        </div>
        <div className="info-txt">
          <h3>Our Objectives:</h3>
          <p className="pt-3">
            <ul className="about-ul">
              <li>
                To expand our international client base across key markets in
                the USA, Europe, Middle East, and Asia.
              </li>
              <li>
                To maintain the highest standards of product quality, packaging,
                and delivery timelines.
              </li>
              <li>
                To foster long-term relationships with our partners, built on
                trust and performance.
              </li>
              <li>
                To consistently diversify our product offerings to meet changing
                global demands.
              </li>
              <li>
                To adopt sustainable and ethical business practices that support
                both local communities and the global economy.
              </li>
            </ul>
          </p>
        </div>
      </div>
    </>
  );
}

export default About;
